import React, { useCallback } from 'react';
import { errMsg } from '@/components/PageElement/ErrorMessage';
import Modal from '@/components/PageElement/Modal';
import { successMsg } from '@/components/PageElement/SuccessMessage';
import { removeProjecWhitelist } from 'api/project/project_remove_whitelist';

interface IDeleteWhitelistProps {
  openDelete: boolean;
  toggleDelete: () => void;
  id: number;
  deleteAddr: string;
  getProjectWhitelistRaffle: (isUpdate?: boolean) => void;
}

const DeleteWhitelist: React.FC<IDeleteWhitelistProps> = ({
  id,
  openDelete,
  toggleDelete,
  deleteAddr,
  getProjectWhitelistRaffle,
}) => {
  const handleDelete = useCallback(async () => {
    const res = await removeProjecWhitelist(id, deleteAddr);
    if (res?.code === 0) {
      successMsg('Delete successful');
      getProjectWhitelistRaffle(true);
      toggleDelete();
    } else {
      errMsg(res?.msg);
    }
  }, [deleteAddr, getProjectWhitelistRaffle, id, toggleDelete]);

  return (
    <Modal
      open={openDelete}
      handleCancel={toggleDelete}
      handleConfirm={handleDelete}
      title="Confirm delete?"
      isDelete={true}
    >
      <div className="text-base font-normal text-neutral-100">
        It cannot be undone after confirmation.
      </div>
    </Modal>
  );
};

export default DeleteWhitelist;
